/* eslint-disable @next/next/no-img-element */
import React, { FC } from 'react';

import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import styles from './Logo.module.scss';

export type LogoProps = {
  width?: number;
  height?: number;
  variant?: 'color' | 'monotone';
};

const Logo: FC<LogoProps> = ({
  width = 200,
  height = 40,
  variant = 'color',
}) => (
  <img
    src={`${NEXT_STATIC_IMAGES}gmb-logo-${variant}.svg`}
    width={width}
    height={height}
    alt="Getmyboat Logo"
      /* eslint-disable react/no-unknown-property */
      /* @ts-expect-error fetchpriority is new and hasn't been added to the HTMLImageElement type */
    fetchpriority="high"
    className={styles.root}
  />
);

export default Logo;
